export default __webpack_public_path__ + "static/CooperBT-Light-5ea0939fe3d450a2d0e5c88f00447433.woff2";